import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "react-bootstrap";
import Tooltip from "../Common/Tooltip";
import { useForm } from "react-hook-form";
import { posServices } from "../../Services/pos.service";
import ResultModal from "../Common/ResultModal";
import { numbersOnly, positiveNumbersOnly } from "../../Config/Regex";

const ChangePosTagModal = ({ show, handleHide, posId }) => {
  const { t: translator } = useTranslation();
  const { register, handleSubmit, errors, control, formState, setValue } =
    useForm({
      mode: "onChange",
      reValidateMode: "onChange",
    });
  const [serverError, setServerError] = useState(null);
  const [modal, setModal] = useState({
    title: "",
    text: "",
    show: false,
    btnClass: "",
    success: true,
  });

  const handleClose = () => {
    setModal({ show: false });
  };

  const confirmChange = (data) => {
    handleHide();
    posServices
      .changePosTag(posId, data.posTag, Number(data.documentNumber))
      .then((res) => {
        if (res.status === 200) {
          handleHide();
          setModal({
            show: true,
            title: translator("ChangePosTag-SuccessModal-Title"),
            text: translator("ChangePosTag-SuccessModal-Text"),
            btnClass: "btn btn-primary",
            success: true,
          });
        } else {
          setServerError(res.data.errors[0].value);
        }
      })
      .catch((err) => {
        setServerError(err);
      });
  };

  return (
    <>
      <Modal show={show} onHide={handleHide} centered>
        <Modal.Header>
          <Modal.Title>{translator("PosDetail-ChangePosTag")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="form-group">
            <label>{translator("POS-List-Tag")}</label>
            <Tooltip text={translator("POS-Tag-Msg")} />
            <input
              type="text"
              name="posTag"
              className="form-control"
              ref={register({
                required: true,
                maxLength: 20,
                pattern: numbersOnly,
              })}
            />
            {errors.posTag && errors.posTag.type === "required" && (
              <p className="text-danger">
                {translator("ValidationMsg-RequiredField")}
              </p>
            )}
            {errors.posTag && errors.posTag.type === "maxLength" && (
              <p className="text-danger">
                {translator("ValidationMsg-MaxLength20")}
              </p>
            )}
            {errors.posTag && errors.posTag.type === "pattern" && (
              <p className="text-danger">
                {translator("ValidationMsg-NumberOnly")}
              </p>
            )}
          </div>
          <div className="form-group">
            <label>{translator("POS-New_EditPOS-DocumentNumber")}</label>
            <Tooltip text={translator("POS-DocumentNumber-Msg")} />
            <input
              type="text"
              name="documentNumber"
              className="form-control"
              ref={register({
                required: true,
                pattern: positiveNumbersOnly,
              })}
            />
            {errors.documentNumber &&
              errors.documentNumber.type === "required" && (
                <p className="text-danger">
                  {translator("ValidationMsg-RequiredField")}
                </p>
              )}
            {errors.documentNumber &&
              errors.documentNumber.type === "pattern" && (
                <p className="text-danger">
                  {translator("ValidationMsg-PositiveNumbersOnly")}
                </p>
              )}
          </div>
          {serverError && <p className="text-danger">{serverError}</p>}
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-outline-secondary"
            data-dismiss="modal"
            onClick={handleHide}
          >
            {translator("General-Close")}
          </button>
          <button
            onClick={handleSubmit(confirmChange)}
            type="button"
            className="btn btn-primary"
          >
            {translator("Btn-Change")}
          </button>
        </Modal.Footer>
      </Modal>

      <ResultModal
        show={modal.show}
        title={modal.title}
        text={modal.text}
        btnClass={modal.btnClass}
        handleClose={handleClose}
      />
    </>
  );
};

export default ChangePosTagModal;
